import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const VerifyIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width, viewBox = '0 0 24 24' }) => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width={remCss(width)}
        height={remCss(width)}
        viewBox={viewBox}
        fill='none'
      >
        <path
          d='M3 12C3 4.5885 4.5885 3 12 3C19.4115 3 21 4.5885 21 12C21 19.4115 19.4115 21 12 21C4.5885 21 3 19.4115 3 12Z'
          stroke={fill}
          strokeWidth='2'
        />
        <path
          d='M9 12L10.6828 13.6828V13.6828C10.858 13.858 11.142 13.858 11.3172 13.6828V13.6828L15 10'
          stroke={fill}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  }
);
VerifyIcon.displayName = 'VerifyIcon';

export default VerifyIcon;
